import(/* webpackMode: "eager" */ "/vercel/path0/components/BlogArticle.js")